import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";
import { ITypesCharacteristicsListSearch } from "../../types/TypesCharacteristicsListSearch";
import { IDeleteValuesTypesCharacteristicsParams } from "../../types/DeleteValuesTypesCharacteristicsParams";
import { ITypesCharacteristicsObjectListSearch } from "../../../TypesCharacteristicsObject/types/TypesCharacteristicsObjectListSearch";

export const searchTypesCharacteristicsRoute = (searchParams: ITypesCharacteristicsListSearch) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-types", "pageable-search"].join("/"),
    searchParams: { ...searchParams, sort: "id" },
  });
};

export const createTypesCharacteristicsRoute = () => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-types"].join("/"),
  });
};

export const searchTypesCharacteristicsByIdRoute = (charTypeId: string) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-types", charTypeId].join("/"),
  });
};

export const getTypesCharacteristicsDicRoute = (dictType: string) => {
  return buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${dictType}` });
};

export const getTypesCharacteristicsDictionaryTypesRoute = () => {
  return buildUrl({ url: `${baseUrl}/dict-api/dictionary-types` });
};

export const deleteValuesTypesCharacteristicsRoute = (
  deleteParams: IDeleteValuesTypesCharacteristicsParams
) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-type-values"].join("/"),
    searchParams: { ...deleteParams },
  });
};

export const addValuesTypesCharacteristicsRoute = (charTypeId: number) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-type-values", charTypeId].join("/"),
  });
};

export const searchTypesCharacteristicsObjectRoute = (
  searchParams: ITypesCharacteristicsObjectListSearch
) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types", "search"].join("/"),
    searchParams: { ...searchParams },
  });
};

export const getTypesCharacteristicsObjectTypesDicRoute = () => {
  return buildUrl({ url: `${baseUrl}/dict-api/object-types` });
};
